var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartProcess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 32.75C14.74 32.75 14.4 32.41 14.4 32V12C14.4 11.59 14.74 11.25 15.15 11.25C15.56 11.25 15.9 11.59 15.9 12V32C15.9 32.41 15.56 32.75 15.15 32.75Z",
    fill: "#1E2254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.35 26.75H15.15C14.74 26.75 14.4 26.41 14.4 26C14.4 25.59 14.74 25.25 15.15 25.25H26.35C27.44 25.25 27.95 24.96 28.05 24.71C28.15 24.46 28 23.9 27.22 23.13L26.02 21.93C25.53 21.5 25.23 20.85 25.2 20.13C25.17 19.37 25.47 18.62 26.02 18.07L27.22 16.87C27.96 16.13 28.19 15.53 28.08 15.27C27.97 15.01 27.4 14.75 26.35 14.75H15.15C14.73 14.75 14.4 14.41 14.4 14C14.4 13.59 14.74 13.25 15.15 13.25H26.35C28.54 13.25 29.24 14.16 29.47 14.7C29.69 15.24 29.84 16.38 28.28 17.94L27.08 19.14C26.83 19.39 26.69 19.74 26.7 20.09C26.71 20.39 26.83 20.66 27.04 20.85L28.28 22.08C29.81 23.61 29.66 24.75 29.44 25.3C29.21 25.83 28.5 26.75 26.35 26.75Z",
    fill: "#1E2254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProcess);
export default __webpack_public_path__ + "static/media/start-process.cca3a15b21bd332e5c670cd3ee39b709.svg";
export { ForwardRef as ReactComponent };